import React, { useState } from "react";
// import _ from "lodash";
import { Formik } from "formik";
import { utils, read } from "xlsx";
import * as Yup from "yup";
import { motion, useCycle } from "framer-motion";
import { useMutation, useLazyQuery } from "@apollo/client";
import { useSelector } from 'react-redux';
import { PhoneNumberFormat, PhoneNumberUtil } from 'google-libphonenumber';

import makeStyles from "@material-ui/core/styles/makeStyles";
import CircularProgress from "@material-ui/core/CircularProgress";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import Autocomplete from '@material-ui/lab/Autocomplete';
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemText from "@material-ui/core/ListItemText";
// import InputAdornment from "@material-ui/core/InputAdornment";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import Box from "@material-ui/core/Box";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import Portal from "@material-ui/core/Portal";
import Snackbar from "@material-ui/core/Snackbar";
import IconButton from "@material-ui/core/IconButton";
import { CloseOutlined } from "@material-ui/icons";

import PageComponent from "../../shared/components/page/page.component";
import CustomLoadingOverlay from '../../shared/components/misc/loading_overlay.component';

import { BUY_DATABUNDLE, BUY_BULK_DATA } from "../../shared/services/mutations/data";
import { GET_DATABUNDLES } from '../../shared/services/queries/data';
import { toUpper } from "lodash";

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "100%",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  paper: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
  },
  box: {
    margin: "10px",
  },
  option: {
    fontSize: 15,
    "& > span": {
      marginRight: 10,
      fontSize: 18,
    },
  },
  layout: {
    width: "auto",
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    marginBottom: theme.spacing(5),
    [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
      width: 650,
      marginTop: theme.spacing(3),
      marginLeft: "auto",
      marginRight: "auto",
    },
  },
  table: {
    backgroundColor: 'white',
    maxHeight: 400,
    overflowX: 'auto'
  },
  listItem: {
    padding: theme.spacing(1, 0),
  },
  buttons: {
    display: "flex",
    justifyContent: "flex-end",
  },
}));

const networks = [
  {
    id: 1,
    name: "mtn",
    logo: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000">
        <title>Nigeria-Logo</title>
        <rect
          x="10"
          y="10.01"
          width="980"
          height="979.97"
          style={{ fill: "#ffc325" }}
        />
        <path
          d="M24.9,500C24.9,397.65,237.61,314.67,500,314.67s475.1,83,475.1,185.34S762.4,685.31,500,685.31,24.9,602.34,24.9,500Z"
          style={{ fill: "#006891" }}
        />
        <path
          d="M24.9,500C24.9,397.65,237.61,314.67,500,314.67s475.1,83,475.1,185.34S762.4,685.31,500,685.31,24.9,602.34,24.9,500Z"
          style={{
            fill: "none",
            stroke: "#006891",
            strokeMiterlimit: 3.8636000000000004,
            strokeWidth: "1.4050876434876893px",
          }}
        />
        <polygon
          points="199.02 590.08 248.33 406.01 326.16 406.01 326.16 514.27 326.67 514.27 379.47 406.01 458.53 406.01 409.22 590.08 357.83 590.08 389.44 472.01 388.93 472.01 326.16 590.08 285.01 590.08 285.01 472.01 284.17 472.01 252.56 590.08 199.02 590.08"
          style={{ fill: "#fff", fillRule: "evenodd" }}
        />
        <polygon
          points="472.44 593.72 479.44 567.56 536.16 567.56 529.15 593.72 472.44 593.72"
          style={{ fill: "#ee4034", fillRule: "evenodd" }}
        />
        <polygon
          points="481.4 560.21 510.09 453.19 458.53 453.19 471.18 406.01 631.01 406.01 618.37 453.19 566.81 453.19 538.13 560.18 481.4 560.21"
          style={{ fill: "#ffc325", fillRule: "evenodd" }}
        />
        <polygon
          points="594.36 590.08 643.64 406.01 699.34 406.01 724.47 504.5 724.96 504.5 751.34 406.01 802.83 406.01 753.54 590.08 700.55 590.08 673.26 489.55 672.77 489.55 645.85 590.08 594.36 590.08"
          style={{ fill: "#fff", fillRule: "evenodd" }}
        />
      </svg>
    ),
  },
  {
    id: 2,
    name: "9mobile",
    logo: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000">
        <title>Nigeria-Logo</title>
        <path
          d="M326.68,894.22q19.24,0,28.12,8.15t8.89,25.35v61.46H344.45V930.32q0-19.44-21.8-19.44a33.1,33.1,0,0,0-17.77,5,47.79,47.79,0,0,1,1.29,11.84v61.46H286.93V930.32q0-19.44-21.8-19.44a55.61,55.61,0,0,0-19.42,3.52v74.78H226.48V903.85a84.77,84.77,0,0,1,20.06-7,102.71,102.71,0,0,1,22.62-2.68q18,0,26.75,7A71.16,71.16,0,0,1,326.68,894.22ZM429.61,992q-22,0-33.07-12.59t-11.08-36.65q0-48.69,44-48.68,22.17,0,33.34,12.49t11.18,36.19q0,23.68-11.54,36.46T429.61,992Zm-.19-16.48q25.29,0,25.28-32.76,0-16.29-6-24.34t-19.24-8.06q-13.37,0-19.14,8.24t-5.77,24.16q0,15.91,5.95,24.34T429.42,975.48Zm108.79-81.26q20.52,0,31.14,12.4T580,941.79q0,27.4-12.73,38.78T534.91,992q-39.39,0-39.39-21.1V859.05h19.06V900a57.17,57.17,0,0,1,12-4.17A51.75,51.75,0,0,1,538.21,894.22Zm-4.77,80.89q15,0,21-8.7t6-23.88q0-15.54-6.32-23.69t-18.77-8.14a44.67,44.67,0,0,0-10.72,1.38,37.65,37.65,0,0,0-10,4v50Q514.58,975.12,533.44,975.11Zm68.3-111.25h20.52v17.59H601.74Zm.55,32.95h19.24l.18,92.37H602.29Zm46.5,92.37V861.09h19.06V989.18ZM732.3,894q21.44,0,31.42,14t9.8,39.15H709q.93,13.7,8,20.83t20.06,7.12a61.57,61.57,0,0,0,29.68-7.59v18.14Q752.45,992,734,992q-20.7,0-32.52-12.68t-11.81-36q0-23.88,11.17-36.55T732.3,894ZM731.75,910q-9.71,0-15.2,5.19t-7.15,17.58h44.52q-1.29-11.85-6.6-17.3T731.75,910ZM548,148.46q-31.83-7.87-49-7.88c-85.39,0-154.62,69-154.62,154.09S413.64,448.77,499,448.77s154.63-69,154.63-154.1a154.18,154.18,0,0,0-4.46-36.89l122.93-33.11a279.1,279.1,0,0,1-36.65,224.24L531.89,826.3H343.31l134-247c.73-1.36-1.42-4.36-3.22-4.52-143.19-13-255.35-133-255.35-279.09,0-154.79,125.9-280.26,281.22-280.26a281.81,281.81,0,0,1,83.86,12.67Z"
          style={{ fill: "#006e53", fillRule: "evenodd" }}
        />
        <circle cx="498.07" cy="294.67" r="84.75" style={{ fill: "#d6e806" }} />
        <path
          d="M644.46,236.89a153.65,153.65,0,0,0-79-82.83M698.4,213.77A218.49,218.49,0,0,0,588.61,98.2m161.8,98.24A273.23,273.23,0,0,0,605.94,46.2"
          style={{
            fill: "none",
            stroke: "#d6e806",
            strokeLinecap: "round",
            strokeWidth: "19.2619642679972px",
          }}
        />
      </svg>
    ),
  },
  {
    id: 3,
    name: "airtel",
    logo: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000">
        <title>Nigeria-Logo</title>
        <path
          d="M617.9,12.26C651,12.72,682.58,19,712.07,34c26,13.31,47.2,31.92,61.67,57.57a156,156,0,0,1,18.19,54.66c5.38,36.84-.06,72.48-12.21,107.33C772.58,274,762.7,293.17,752,312c-21.8,38.33-49.81,71.55-82.39,101a767.92,767.92,0,0,1-136.68,98.71c-19,10.73-38.7,19.74-59.89,25.25A146,146,0,0,1,433.21,542c-17.7-.36-31.55-8.42-42.32-22a64.2,64.2,0,0,1-14.4-43.32,55.77,55.77,0,0,1,1.88-12.94c6.41-22.77,15.12-44.58,28.14-64.47,9.95-15.19,21.81-28.68,37.32-38.33,17.25-10.74,36-15.33,56.28-10.9a47.5,47.5,0,0,1,17.53,8.15c13.35,9.54,12.65,24.51,6.24,34.07a189.11,189.11,0,0,1-18.36,23.51c-11.4,12.28-23.51,23.89-35.33,35.77-10.46,10.51-20.29,21.54-28.26,34.11-4.13,6.52-7.94,13.17-9.08,21-1.44,9.82,3.66,16.51,13.57,17.43a42.39,42.39,0,0,0,15.23-1.53c15.23-4.21,29.37-11,43.26-18.32,21.42-11.33,41.19-25.18,60.46-39.79,23.36-17.71,46.07-36.18,67-56.72,23.84-23.37,45.09-48.77,61.35-78.08,11.88-21.4,20.63-44,24.52-68.24,3.44-21.35,1.52-42.15-8.37-61.75a56.25,56.25,0,0,0-21.46-23.37,40.31,40.31,0,0,0-13.89-5.18c-17.87-3.17-35.16-.57-52.15,5.1-17.71,5.92-34.14,14.56-50.11,24-34.66,20.56-69.36,41.11-102.39,64.26-16.56,11.6-32.61,23.94-48.84,36-14.66,10.9-29.22,21.93-45.24,30.84a144.58,144.58,0,0,1-41.71,15.83c-18.14,3.68-34.86.26-50.22-9.6-15.94-10.23-27.1-24.27-32-42.85-3.12-11.73-1.89-23.36.8-34.94,3.93-17,11.39-32.4,20.69-47,23-36.06,51.92-66.65,85.55-92.8,49.84-38.75,104.68-68.59,164-90.18A288,288,0,0,1,617.9,12.26Z"
          style={{ fill: "#e20010" }}
        />
        <path
          d="M207.86,836.7c-.17-11.32-1.46-21.5-8-30.33a26.2,26.2,0,0,0-12.64-9.16c-13-4.66-26.24-4.11-39.15-.12-10.35,3.2-20.33,7.56-30.46,11.45-2,.74-3.82,1.69-6.24,2.77C106.6,799.48,101.91,788,97,776c7.11-3.37,13.81-6.81,20.72-9.76,15.92-6.81,32.43-11.48,49.79-12.53S202,753.58,217.8,762c17.87,9.46,30.77,23.12,36.17,43a34.23,34.23,0,0,1,1.39,8c.69,25.81,1.62,51.62,1.73,77.43.07,17.64-1.09,35.29-1.61,52.94a9.56,9.56,0,0,1-2.82,6.42c-12.35,13.6-27.46,23-44.58,29.31a141,141,0,0,1-57.41,8.25c-18-1-33.54-8.37-46.68-20.6s-22.32-27-24.88-45.1c-3.5-24.79,3.65-46.3,21.47-64,11.46-11.38,25.58-17.26,41.49-19.34,17.6-2.29,35.26-1.68,52.92-1.63ZM205.55,877a27,27,0,0,0-3.14-.43c-6-.12-12.07-.33-18.1-.24-7.23.11-14.49.14-21.68.82-7.43.71-14.64,2.88-20.4,7.84-9.56,8.24-12.4,19-10.07,31.13,2.9,15,11.28,25.48,26.22,29.94a48.28,48.28,0,0,0,23.73,1,41.64,41.64,0,0,0,19.76-9.48,8.43,8.43,0,0,0,3.25-6.18c.23-5.27.91-10.53.95-15.8.08-12.07-.1-24.14-.2-36.21A20.61,20.61,0,0,0,205.55,877Z"
          style={{ fill: "#e20010" }}
        />
        <path
          d="M809.33,876c-42.9,0-85-.92-127.69.2.22,3,.35,5.84.62,8.61,1.1,11.33,3.54,22.34,8.33,32.73a55.6,55.6,0,0,0,16.82,21.56c11.6,8.81,24.84,10.25,38.73,8.46,11.48-1.48,22.17-5.68,32.83-9.91,4.89-1.93,9.74-4,15-6.15,5,10.46,9.9,20.74,15,31.32-.94.68-1.82,1.44-2.8,2-20.8,12.34-43.14,20.29-67.27,22.39-22,1.91-43-1.7-62-13.87-12.94-8.29-22-20-29.58-33.1a128.61,128.61,0,0,1-16.56-53.16Q626,835.89,652.5,791.76c12.32-20.45,30.71-31.56,53.73-35.39A94.16,94.16,0,0,1,768,766.65c10.54,5.71,17.88,14.7,23.93,24.78,8,13.29,12.21,27.94,14.23,43.12,1.64,12.24,2.16,24.63,3.14,37C809.42,872.82,809.33,874.14,809.33,876Zm-52-38.85c-2.49-11.41-4.19-23.07-11.66-32.74a27,27,0,0,0-14.93-9.64c-15.75-4.17-31.58,3.09-38.35,18-2.42,5.31-3.84,11.08-5.6,16.67-.79,2.53-1.3,5.16-1.93,7.71C689.09,838.27,753,838.32,757.35,837.18Z"
          style={{ fill: "#e20010" }}
        />
        <path
          d="M527.9,701.71l51.19-7.92v62.87c11.36.68,22.18-.06,33.06,1.11V796.5c-11,.18-21.77-.15-33,.53,0,2.18,0,3.81,0,5.44q-.14,55.92-.24,111.85c0,5.87.47,11.75,1,17.6.84,9,5.83,14.71,14.55,16.9,4.81,1.22,9.75,1.91,14.63,2.84l4.9,1v32.87a6.69,6.69,0,0,1-1.74.58c-14.53.65-29,.27-43.05-4-13.72-4.14-25.16-11.64-32.92-24-4.41-7-6.65-14.87-7.62-23a131.09,131.09,0,0,1-.86-15.34q0-106.2.12-212.38Z"
          style={{ fill: "#e20010" }}
        />
        <path
          d="M837.47,701.75l49.5-8.58V700q0,96.45.08,192.9c0,11.77.1,23.54.19,35.32.08,11.62,4.32,17.54,15.42,21a100.35,100.35,0,0,0,11.47,2.46c2.36.44,4.75.65,7.62,1v33.58a2.18,2.18,0,0,1-.92.45c-14.06.57-28.06.34-41.73-3.66a63.65,63.65,0,0,1-22.67-11.88C844,961,838.94,947.37,837.64,932c-.38-4.5-.33-9.05-.32-13.57q0-105.51.15-211Z"
          style={{ fill: "#e20010" }}
        />
        <path
          d="M428.38,983.29h-50c-.06-2.09-.16-4-.17-5.89q-.08-45.06-.13-90.12c-.06-24-.21-48-.2-72a89.21,89.21,0,0,1,1-13c.74-4.91,3.31-9,6.88-12.45,19.64-19.12,43.17-30.58,70-35.52a142.09,142.09,0,0,1,50.87-.07c.89.16,1.78.36,2.65.58.43.11.84.32,1.67.64-5.68,14.44-12.6,28.24-19.12,41.88-7.79,0-15.17-.23-22.53.05a90.09,90.09,0,0,0-36.61,9.12c-3.24,1.59-4.45,3.57-4.44,7.3q.21,82,.1,164Z"
          style={{ fill: "#e20010" }}
        />
        <path
          d="M341.5,758.78c.53,74.92-.05,149.4.43,224.34H293c-.12-1.81-.36-3.7-.36-5.59q0-70.65,0-141.32c0-21.59.18-43.18.27-64.77,0-1.64,0-3.28,0-5.34Z"
          style={{ fill: "#e20010" }}
        />
        <path
          d="M315,736.73c-23.89-.06-38.85-23.84-28.94-46.29,6.09-13.77,16.55-19,31.64-18.91,20.22.17,35.21,20.28,30.39,39.93C344.24,727.16,331.64,736.77,315,736.73Z"
          style={{ fill: "#e20010" }}
        />
      </svg>
    ),
  },
  {
    id: 4,
    name: "glo",
    logo: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000">
        <defs>
          <linearGradient
            id="a"
            x1="484.48"
            y1="319.34"
            x2="536.14"
            y2="785.87"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#123214" />
            <stop offset="0.46" stopColor="#3e7c37" />
            <stop offset="0.91" stopColor="#5fbb46" />
          </linearGradient>
          <linearGradient
            id="b"
            x1="4812.32"
            y1="-2121.07"
            x2="4812.32"
            y2="-2122.13"
            gradientTransform="matrix(115.64, 0, 0, -355.9, -555713.76, -754599.8)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#fff" stopOpacity="0" />
            <stop offset="0.64" stopColor="#fff" stopOpacity="0.43" />
            <stop offset="1" stopColor="#fff" stopOpacity="0.42" />
          </linearGradient>
          <radialGradient
            id="c"
            cx="1772.25"
            cy="-341.52"
            fy="-409.14889841083107"
            r="151.52"
            gradientTransform="matrix(1.17, 0.59, -0.28, 0.47, -1527.13, -664.3)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.13" stopColor="#fff" />
            <stop offset="0.29" stopColor="#fff" stopOpacity="0.69" />
            <stop offset="0.45" stopColor="#fff" stopOpacity="0.4" />
            <stop offset="0.59" stopColor="#fff" stopOpacity="0.18" />
            <stop offset="0.69" stopColor="#fff" stopOpacity="0.05" />
            <stop offset="0.74" stopColor="#fff" stopOpacity="0" />
          </radialGradient>
          <radialGradient
            id="d"
            cx="570.86"
            cy="398.43"
            fx="613.1001782573674"
            fy="841.347906680515"
            r="444.93"
            gradientTransform="translate(410.75 -300.75) rotate(39.84) scale(1 1.09)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.86" stopOpacity="0" />
            <stop offset="0.98" stopOpacity="0.47" />
            <stop offset="1" />
          </radialGradient>
        </defs>
        <circle
          cx="502.49"
          cy="490.94"
          r="401.79"
          style={{ fill: "#50b651" }}
        />
        <path
          d="M903.05,489.81c0,222.6-180.45,403.05-403,403.05S97,712.41,97,489.81c0-98.47,2.76-113.11,41.52-169.17,0,0-2,63.32,44.43,101,28.87,23.41,59,6.51,114.15-18.89,59.66-27.5,108.16-45.24,146-40.56,57,7.06,232.69,112.57,324.38,91.56C840.73,437,833,264.3,833,264.3,913,342.42,903.05,395.22,903.05,489.81Z"
          style={{
            fillRule: "evenodd",
            opacity: 0.6629999876022339,
            isolation: "isolate",
            fill: "url(#a)",
          }}
        />
        <path
          d="M673,785.86q218.65-205.67,72.69-471.24.74.54,18.06-62.32,77.68,94.07,82.61,232.22Q846.32,663.46,673,785.86Z"
          style={{
            fillRule: "evenodd",
            opacity: 0.5860000252723694,
            isolation: "isolate",
            fill: "url(#b)",
          }}
        />
        <path
          d="M603.86,253.13C533.5,214.19,452.78,135.86,463.51,119.41s150-13.62,220.37,25.32,130.26,155.75,119.54,172.2S674.22,292.07,603.86,253.13Z"
          style={{
            fillRule: "evenodd",
            opacity: 0.7440000176429749,
            isolation: "isolate",
            fill: "url(#c)",
          }}
        />
        <path
          d="M665.15,589.89c-58.37,0-105.69-48.67-105.69-108.7S606.78,372.5,665.15,372.5s105.7,48.66,105.7,108.69S723.53,589.89,665.15,589.89Zm.75-34.48c36.43,0,66-33.23,66-74.22S702.33,407,665.9,407s-66,33.23-66,74.21S629.47,555.41,665.9,555.41Z"
          style={{ fill: "#fff", fillRule: "evenodd" }}
        />
        <polygon
          points="447.08 284.98 523.24 284.98 523.24 588.68 481.43 588.68 481.43 318.29 447.08 318.29 447.08 284.98"
          style={{ fill: "#fff", fillRule: "evenodd" }}
        />
        <path
          d="M390.32,375.59h39.53V629.21c0,23.11-24.31,47.18-48,57.54q-16.8,7.34-62,8.72V670.24q44.21-4.93,59.68-19.67a59.29,59.29,0,0,0,10.8-28.06V548q-15.85,33.63-39.92,44.59c-16.68,9-50.63,7.52-64.49,0s-34.19-27.32-43.51-56.81c-2.58-8.14-9-30.29-8.33-53.76.6-22.35,8-46,14.15-55.72,10.56-16.6,27.21-37.39,52.43-46.08q18.48-6.37,68.5-4.58v25.09q-37.17-2.51-46.38,2.51c-9.21,5-30,11.17-36.86,56.48s.2,82.39,21.95,94c7.45,4,20.63,8.73,32.81,4.56,23.4-8,45.42-36.53,47.1-55.86Q390.32,473,390.32,375.59Z"
          style={{ fill: "#fff", fillRule: "evenodd" }}
        />
        <path
          d="M890.42,570.48C853.09,750.23,693.81,885.29,503,885.29c-218.53,0-395.69-177.16-395.69-395.69,0-135.76,68.37-255.55,172.55-326.8C195.21,233,141.31,339.05,141.31,457.64c0,211.53,171.48,383,383,383C696.57,840.64,842.25,726.93,890.42,570.48Z"
          style={{ fill: "url(#d)", fillRule: "evenodd" }}
        />
        <path
          d="M503,21C244.2,21,34.39,230.8,34.39,489.6S244.2,958.21,503,958.21,971.61,748.4,971.61,489.6,761.8,21,503,21Zm0,864.3c-218.53,0-395.69-177.16-395.69-395.69,0-135.76,68.37-255.55,172.55-326.8A393.82,393.82,0,0,1,503,93.91c218.53,0,395.69,177.15,395.69,395.69a397.6,397.6,0,0,1-8.27,80.88C853.09,750.23,693.81,885.29,503,885.29Z"
          style={{ fill: "#fff", fillRule: "evenodd" }}
        />
      </svg>
    ),
  },
];

export default function BuyDataComponent() {
  const classes = useStyles();

  const [isOpen] = useCycle(true, false);

  const [buyType, setBuyType] = React.useState("single");

  const variants = {
    open: (height = 1000) => ({
      clipPath: `circle(200% at 100% 100%)`,
      transition: {
        type: "spring",
        stiffness: 20,
        restDelta: 2,
      },
    }),
    closed: {
      clipPath: "circle(10% at 100% 100%)",
      transition: {
        delay: 0.5,
        type: "spring",
        stiffness: 400,
        damping: 40,
      },
    },
  };

  return (
    <PageComponent className={classes.root} title="Buy Internet | Admin">
      <motion.div animate={isOpen ? "open" : "closed"} variants={variants}>
        <React.Fragment>
          <main className={classes.layout}>
            {/* Select Buy Type */}
            <Grid item md={12} className={classes.paper}>
              <FormControl fullWidth variant="outlined">
                <Paper elevation={4} />
                <InputLabel>Select Type</InputLabel>
                <Select
                  label="Select Type"
                  onChange={(event) => setBuyType(event.target.value)}
                  value={buyType}
                >
                  {["single", "bulk"].map((name) => (
                    <MenuItem key={name} value={name}>
                      {toUpper(name)}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Container maxWidth={false}>
              {buyType === "single" ? (
                <BuySingleDataComponent />
              ) : (
                <BuyBulkDataComponent />
              )}
            </Container>
          </main>
        </React.Fragment>
      </motion.div>
    </PageComponent>
  );
}

const BuySingleDataComponent = () => {
  const classes = useStyles();

  const [open, setOpen] = React.useState(false);

  const [snackbarMessage, setSnackbarMessage] = React.useState("");

  const [dataBundles, setDataBundles] = React.useState([]);

  const [getDataBundles] = useLazyQuery(GET_DATABUNDLES, {
    fetchPolicy: "no-cache",
    onCompleted: (data) => {
      console.log(data);
      setDataBundles(data.getDataBundles);
    },
    onError: () => {

    },
  });

  const [buyDataBundle] = useMutation(BUY_DATABUNDLE, {
    fetchPolicy: "no-cache",
  });

  React.useEffect(() => {
    getDataBundles({
      variables: {
        network: "mtn",
      },
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Portal>
        <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          open={open}
          onClose={(event, reason) =>
            reason === "clickaway" ? null : setOpen(false)
          }
          message={snackbarMessage}
          action={
            <IconButton onClick={() => setOpen(false)}>
              <CloseOutlined style={{ color: "white" }} />
            </IconButton>
          }
        />
      </Portal>
      <Grid item md={12}>
        <Paper elevation={4} />
        <Formik
          initialValues={{
            phonenumber: "",
            network: "mtn",
            amount: 0,
          }}
          validationSchema={Yup.object().shape({
            phonenumber: Yup.string()
              .required("Phonenumber is required")
              .min(
                11,
                "Please ensure your phonenumber is eleven characters and starts with a zero"
              )
              .max(
                11,
                "Please ensure your phonenumber is eleven characters and starts with a zero"
              )
              // eslint-disable-next-line func-names
              .test("isValid", "Invalid phonenumber", function (value) {
                if (value === undefined) return false;
                return /(^0)(7|8|9){1}(0|1){1}[0-9]{8}/.test(
                  value.trim().replace(/\s/g, "")
                );
              }),
            amount: Yup.number().required("Amount is required"),
            network: Yup.string().required("Network is required"),
            code: Yup.string().required("Data plan is required"),
          })}
          onSubmit={async (values, { resetForm }) => {
            let data;
            try {
              data = await buyDataBundle({
                variables: {
                  phonenumber: values.phonenumber,
                  itemCode: values.code,
                  network: values.network,
                  amount: values.amount,
                },
              });
            } catch (e) {
              setSnackbarMessage("Something went wrong");
              setOpen(true);
              return;
            }

            if (!data.errors) {
              if (data.data?.buyDataBundle?.success) {
                resetForm();
              }

              setSnackbarMessage(data.data?.buyDataBundle?.message);
              setOpen(true);
              return;
            }

            setSnackbarMessage(data.errors[0]?.originalError?.message);
            setOpen(true);
          }}
        >
          {({
            errors,
            handleBlur,
            handleChange,
            handleSubmit,
            isSubmitting,
            setFieldValue,
            touched,
            values,
          }) => (
            <form onSubmit={handleSubmit}>
              <Paper elevation={4} className={classes.paper}>
                <Box
                  className={classes.box}
                  display={"flex"}
                  justifyContent={"center"}
                  width={"100%"}
                  paddingBottom={"20px"}
                >
                  <Typography component="h1" variant="h3" align="center">
                    Buy Internet
                  </Typography>
                </Box>
                <>
                  <TextField
                    id="phonenumber"
                    variant="outlined"
                    margin="normal"
                    label="Phonenumber"
                    required
                    type="text"
                    fullWidth
                    name="phonenumber"
                    placeholder="Enter the recipient's phone number"
                    // sx={style.textField}
                    value={values.phonenumber.trim().replace(/\s/g, "")}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={Boolean(touched.phonenumber && errors.phonenumber)}
                    helperText={touched.phonenumber && errors.phonenumber}
                    autoComplete="phonenumber"
                  />
                </>
                <Box padding="15px" />
                <>
                  <FormControl fullWidth variant="outlined">
                    {/* <InputLabel>Network</InputLabel> */}
                    <Box padding="5px" />
                    <div style={{display: "flex", flexDirection: "row", gap: 2}}>
                      {networks.map(({ id, logo, name }) => (
                        <Box
                          key={id}
                          style={{
                            height: "70px",
                            width: "70px",
                            border:
                              values.network === name
                                ? `2px solid rgba(69, 180, 29, 1)`
                                : `1px solid rgba(51, 51, 51, 0.2)`,
                            borderRadius: "5px",
                            padding: "20px 20px 0px 20px",
                          }}
                          onClick={() => {
                            if (name === values.network) return;

                            setFieldValue("network", name);
                            getDataBundles({
                              variables: {
                                network: name,
                              },
                            });
                          }}
                        >
                          {logo}
                        </Box>
                      ))}
                    </div>
                    
                  </FormControl>
                </>
                <Box padding="15px" />
                <RadioGroup
                  name="code"
                  onChange={(e) => setFieldValue("code", e.target.value)}
                >
                  {dataBundles.map(({ name, datacode, price }, index) => (
                    <FormControlLabel
                      // eslint-disable-next-line react/no-array-index-key
                      key={index}
                      control={<Radio />}
                      value={datacode}
                      onClick={() => setFieldValue("amount", price)}
                      label={
                        <Typography variant="caption" fontWeight={400}>
                          {name}
                        </Typography>
                      }
                    />
                  ))}
                </RadioGroup>
                <Box padding="15px" />
                <Box display="flex">
                  <Button
                    variant={"contained"}
                    color={"primary"}
                    disabled={isSubmitting}
                    type={"submit"}
                  >
                    {isSubmitting ? <CircularProgress /> : "Buy"}
                  </Button>
                </Box>
              </Paper>
            </form>
          )}
        </Formik>
      </Grid>
    </>
  );
};

const BuyBulkDataComponent = () => {
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [file, setFile] = React.useState(null);
  const [array, setArray] = React.useState([]);
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [user, setUser] = React.useState(null);
  const [open, setOpen] = React.useState(false);

  const [snackbarMessage, setSnackbarMessage] = React.useState("");

  const phoneUtil = PhoneNumberUtil.getInstance();

  const customersState = useSelector((state) => state.customersState);

  const [network, setNetwork] = React.useState("mtn");
  const [code, setCode] = React.useState("");
  const [amount, setAmount] = React.useState(0);
  const [dataBundles, setDataBundles] = React.useState([]);

  const [getDataBundles] = useLazyQuery(GET_DATABUNDLES, {
    fetchPolicy: "no-cache",
    onCompleted: (data) => {
      setDataBundles(data.getDataBundles);
    },
    onError: () => {},
  });

  const [buyBulkData] = useMutation(BUY_BULK_DATA, {
    fetchPolicy: "no-cache",
  });

  const parseArray = (array) => {
    return array
      .filter((t) => t["Mobile Number"].toString().trim() !== "Total")
      .map((t) => {
        let phonenumber = t["Mobile Number"].toString().replace(/[^0-9]/g, "");
        const parsed = `${phoneUtil.format(
          phoneUtil.parse(phonenumber, "NG"),
          PhoneNumberFormat.NATIONAL
        )}`
          .replace(/\s/g, "")
          .slice(-10);
        return {
          phonenumber: `0${phoneUtil.parse(parsed, "NG").getNationalNumber()}`,
          // network: t['network'],
          // amount: t["Amount"],
          name: t['Beneficiray name'] || t['Name'] || t['Beneficiary name']
        };
      });
  };
  
  // const addNetwork = (array, sheetName) => {
  //   return array.map((a) => ({ ...a, network: _.toLower(sheetName) }));
  // }

  const handleSubmit = async () => {
    setIsSubmitting(true);

    let data;
    try {
      data = await buyBulkData({
        variables: {
          userId: user.id,
          phonenumbers: array[page]
            .map((a) => ({
              phonenumber: a.phonenumber,
              network: network,
              amount: amount,
              itemCode: code,
              // name: a.name,
            }))
        },
      });
    } catch (e) {
      console.error(e);
      setIsSubmitting(false);
      setSnackbarMessage("Something went wrong");
      setOpen(true);
      return;
    }

    setIsSubmitting(false);

    if (!data.errors) {
      if(page + 1 < array.length) {
        setPage(page + 1);
      }

      setSnackbarMessage(data.data?.buyBulkData?.message);
      setOpen(true);
      return;
    }

    setSnackbarMessage(data.errors[0]?.originalError?.message);
    setOpen(true);
  };
  
  const loadFile = (files) => {
    setFile(files?.item(0));
    const reader = new FileReader();
    reader.onload = (e) => {
      const data = e.target.result;
      const workbook = read(data, { type: "array" });
      let phonenumbers = [];

      for(const element of workbook.SheetNames) {
        const sheetName = element;
        const worksheet = workbook.Sheets[sheetName];
        const json = utils.sheet_to_json(worksheet);

        const parsedArray = parseArray(json);
        phonenumbers = [...phonenumbers, ...parsedArray];
        // if(
        //   ['mtn', '9mobile', 'airtel', 'glo']
        //     .includes(_.toLower(sheetName))
        // ) {
        // }
      }

      console.log({phonenumbers});

      const perChunk = 50 // items per chunk    

      const result = phonenumbers
        .map((a, index) => ({ id: index + 1, ...a }))
        .reduce((resultArray, item, index) => {
          const chunkIndex = Math.floor(index/perChunk)

          if(!resultArray[chunkIndex]) {
            resultArray[chunkIndex] = [] // start a new chunk
          }

          resultArray[chunkIndex].push(item)

          return resultArray
        }, [])

      setArray(result);
    };
    reader.readAsArrayBuffer(files.item(0));
  }

  React.useEffect(() => {
    getDataBundles({
      variables: {
        network: "mtn",
      },
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
        <Portal>
            <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            open={open}
            onClose={(event, reason) =>
                reason === "clickaway" ? null : setOpen(false)
            }
            message={snackbarMessage}
            action={
                <IconButton onClick={() => setOpen(false)}>
                <CloseOutlined style={{ color: "white" }} />
                </IconButton>
            }
            />
        </Portal>
        <Paper elevation={4} className={classes.paper}>
          <Box
              className={classes.box}
              display={"flex"}
              justifyContent={"center"}
              width={"100%"}
              paddingBottom={"20px"}
          >
              <Typography component="h1" variant="h3" align="center">
              Buy Bulk Airtime
              </Typography>
          </Box>
          <>
              {customersState.isLoading ? (
              <CustomLoadingOverlay />
              ) : (
              <>
                <Autocomplete
                  id="user"
                  options={customersState.customers}
                  classes={{
                    option: classes.option,
                  }}
                  autoHighlight
                  getOptionLabel={(option) => option.phonenumber ?? ""}
                  renderOption={(option) => (
                    <ListItemText
                      primary={option.phonenumber}
                      secondary={
                        <span>{`${option.firstname} ${option.lastname}`}</span>
                      }
                    />
                  )}
                  onChange={(event, value) => {
                    return value !== null ? setUser(value) : null;
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      id="user"
                      type="text"
                      label="User"
                      // error={Boolean(touched.meternumber && errors.meternumber)}
                      // helperText={touched.meternumber && errors.meternumber}
                      variant="outlined"
                      autoComplete="off"
                      onChange={(event, value) => {
                        console.log(`${event.target.value}`, value);
                        // setUser(event.target.value);
                      }}
                      inputProps={{
                          ...params.inputProps, // disable autocomplete and autofill
                      }}
                    />
                  )}
                />
                <Box padding="15px" />
                <FormControl fullWidth variant="outlined">
                  {/* <InputLabel>Network</InputLabel> */}
                  <Box padding="5px" />
                  <div style={{display: "flex", flexDirection: "row", gap: 2}}>
                    {networks.map(({ id, logo, name }) => (
                      <Box
                        key={id}
                        style={{
                          height: "70px",
                          width: "70px",
                          border:
                            network === name
                              ? `2px solid rgba(69, 180, 29, 1)`
                              : `1px solid rgba(51, 51, 51, 0.2)`,
                          borderRadius: "5px",
                          padding: "20px 20px 0px 20px",
                        }}
                        onClick={() => {
                          if (name === network) return;

                          setNetwork(name);
                          getDataBundles({
                            variables: {
                              network: name,
                            },
                          });
                        }}
                      >
                        {logo}
                      </Box>
                    ))}
                  </div>
                  
                </FormControl>
                <Box padding="15px" />
                <RadioGroup
                  name="code"
                  onChange={(e) => setCode(e.target.value)}
                >
                  {dataBundles.map(({ name, datacode, price }, index) => (
                    <FormControlLabel
                      // eslint-disable-next-line react/no-array-index-key
                      key={index}
                      control={<Radio />}
                      value={datacode}
                      onClick={() => setAmount(price)}
                      label={
                        <Typography variant="caption" fontWeight={400}>
                          {name}
                        </Typography>
                      }
                    />
                  ))}
                </RadioGroup>
                <Box padding="15px" />
                <Box display={'flex'} justifyContent={'space-between'}>
                  <label>
                    <input
                      accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                      type="file"
                      hidden
                      onChange={({ target: { files } }) => {
                        loadFile(files);
                      }}
                    />
                    <span style={{ marginRight: "5px" }}>
                        {file === null ? <i>No file uploaded</i> : file.name}
                    </span>
                    <span className="MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedPrimary">
                      Select file
                    </span>
                  </label>
                  {
                    array.length > 0 && <FormControl variant="outlined">
                      <InputLabel>Page</InputLabel>
                      <Select
                        id="page"
                        name="page"
                        label="Page"
                        onChange={(event) => setPage(event.target.value)}
                        value={page}
                      > 
                        {new Array(array.length).fill().map((number, index) => (
                          <MenuItem key={index} value={index}>
                            {index + 1}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  } 
                </Box>
                <Box padding="15px" />
                {
                  array.length > 0 && <DisplayTable rows={array[page]} />
                }
                <Box padding="15px" />
                <Box display="flex">
                  <Button
                    variant={"contained"}
                    color={"primary"}
                    disabled={isSubmitting || user === null}
                    onClick={() => handleSubmit()}
                  >
                    {isSubmitting ? <CircularProgress /> : "Buy"}
                  </Button>
                </Box>
              </>
              )}
          </>
        </Paper>
    </>
  );
};

const DisplayTable = ({ rows }) => {
  const classes = useStyles();

  return (
    <TableContainer className={classes.table}>
      <Table aria-label="transactions table">
        <TableHead>
          <TableRow>
            <TableCell></TableCell>
            <TableCell>Name</TableCell>
            <TableCell>Phonenumber</TableCell>
            {/* <TableCell>Network</TableCell>
            <TableCell>Amount</TableCell> */}
          </TableRow>
        </TableHead>
        <TableBody>
          {
            rows.map((row, index) => (
              <TableRow key={index}>
                <TableCell component="th" scope="row">
                  {row.id}
                </TableCell>
                <TableCell component="th" scope="row">
                  {row.name}
                </TableCell>
                <TableCell component="th" scope="row">
                  {row.phonenumber}
                </TableCell>
                {/* <TableCell component="th" scope="row">
                  {row.network}
                </TableCell>
                <TableCell component="th" scope="row">
                  {row.amount}
                </TableCell> */}
              </TableRow>
            ))
          }
        </TableBody>
      </Table>
    </TableContainer>
  )
}
